<template>
  <div
    class="box cursor-pointer"
    @click.prevent="toggleEvent"
  >
    <div class="media">
      <div class="media-left">
        <span class="icon">
          <CheckboxMarked v-if="event.selected" />
          <CheckboxBlankOutline v-else/>
        </span>
      </div>
      <div class="media-content">
        <div class="content">
          <div class="level is-mobile">
            <div class="level-left">
              <p><strong>{{ event.name }}</strong></p>
            </div>
            <div class="level-right">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxBlankOutline from 'vue-material-design-icons/CheckboxBlankOutline.vue'
import CheckboxMarked from 'vue-material-design-icons/CheckboxMarked.vue'

export default {
  name: 'EventItem',
  components: {
    CheckboxBlankOutline,
    CheckboxMarked
  },
  props: {
    event: {
      type: Object,
      required: true,
      default: () => {
        return {
          name: 'N/A',
          selected: false
        }
      }
    }
  },
  methods: {
    toggleEvent () {
      this.$emit('toggleEvent', { _id: this.event._id, selected: !this.event.selected })
    }
  }
}
</script>
